import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { DataService, GUEST_VEHICLE_ID } from 'src/app/services/data.service';
import { QrPaymentformPage } from '../qr-paymentform/qr-paymentform.page';
import { endOfDay, format, intervalToDuration, parseISO, startOfDay } from 'date-fns';
import { ReceiptPage } from '../receipt/receipt.page';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { LanguageService } from 'src/app/services/language.service';
import { ToastService } from 'src/app/services/toast.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnterlotpasswordPage } from 'src/app/pages/enterlotpassword/enterlotpassword.page';

@Component({
  selector: 'app-qrcode-permit',
  templateUrl: './qrcode-permit.page.html',
  styleUrls: ['./qrcode-permit.page.scss'],
})
export class QrcodePermitPage {
  guestVehicleID = GUEST_VEHICLE_ID
  permitType = 'hourly';
  zeroDollarPayment;
  // disclaimer
  paymentTypes;
  @Input() id
  @Input() fromScanner?
  @Input() isModal: any;
  @Input() lotPasswordEnabled
  paymentForm: FormGroup = new FormGroup({});
  lot;
  vehicles;
  loaded = false
  tempPermitFormDaily: FormGroup;
  tempPermitFormHourly: FormGroup;
  tempPermitState = {

    checking: false,
    valid: false,
  };
  errors = {};
  postData = {};
  permitDetails = {};
  payType:any = ''
  provinces;
  width = window.innerWidth;
  disableHourly = true;
  disableDaily = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private alertCtrl: AlertController,
    private errorHandlerSRV: ErrorHandlerService,
    private toastSRV: ToastService,
    private disclaimerSRV: DisclaimersService,
    private navCtrl: NavController,
    private fb: FormBuilder,
    public platformSRV: PlatformService,
    private modalCtrl: ModalController,
    public dataSRV: DataService,
    public translateService: TranslateService,
  ) {

   this.resetForm()
  }
  resetPaymentForm(){
    this.paymentForm = this.fb.group({
      'email': '',
      'name': '',
      'phone_number': '',
      'address_1': '',
      'address_2': '',
      'city': '',
      'province': '',
      'postal': '',
      'cardName': '',
      'cardNumber': '',
      'cardNumberMask': '',
      'cardExpiryMonth': '',
      'cardExpiryYear': '',
      'cardCVVD': ''
    });
  }
  resetForm(){
      this.resetPaymentForm()
    if (this.dataSRV.isAuthenticated.value == true) {
      this.tempPermitFormHourly = this.fb.group({
        "vehicle": "",
        "hours": "",
        "plate": ""
      })
      this.tempPermitFormDaily = this.fb.group({
        "vehicle": "",
        "permitType": 'daily',
        "plate": "",
        "dailyStartDate": "",
        "dailyEndDate": ""
      })
    } else {
      this.tempPermitFormHourly = this.fb.group({
        "plate": ["", Validators.required],
        "hours": ["", Validators.required]
      })
      this.tempPermitFormDaily = this.fb.group({
        "dailyStartDate": "",
        "dailyEndDate": "",
        "permitType": 'daily',
        "plate": ["", Validators.required]
      })
    }
  }
  plateChanged() {
    this.tempPermitState.valid = false;
    this.tempPermitState.checking = false;
  }
  hoursChanged() {
    this.tempPermitState.valid = false;
    this.tempPermitState.checking = false;
  }
  vehiclesChanged() {
    this.tempPermitState.valid = false;
    this.tempPermitState.checking = false;
  }
  segmentChanged(ev) {
    this.tempPermitState.valid = false;

    this.tempPermitState.checking = false;
    this.permitDetails = {};
  }
  async proceed() {

    const summary = {
      taxes: this.permitDetails['taxes'],
      total: this.permitDetails['total'],
      sub_total: this.permitDetails['rate']
    }
    if (summary['total'] == 0) {
      this.payType = this.zeroDollarPayment

    }
    if (this.payType != '' || summary['total'] == 0) {
      if (this.payType?.promptFor?.toLowerCase() == 'anonymous' && this.dataSRV.isAuthenticated.value == true) {
        this.paymentForm = this.fb.group({
          'email': this.dataSRV.user['email']
        })
      } else if (this.payType?.promptFor?.toLowerCase() == 'billing') {
        this.paymentForm = this.fb.group({
          'email': this.dataSRV.user['email'],
          'name': this.dataSRV.user['firstName'] + ' ' + this.dataSRV.user['lastName'],
          'phone_number': this.dataSRV.user['phonecell'],
          'address_1': this.dataSRV.user['street'],
          'address_2': this.dataSRV.user['street2'],
          'city': this.dataSRV.user['city'],
          'province': this.dataSRV.user['prov'],
          'postal': this.dataSRV.user['postal']
        })
      }
      else if (this.payType?.promptFor?.toLowerCase() == 'creditcard') {
        this.paymentForm = this.fb.group({
          'cardName': '',
          'cardNumber': '',
          // 'cardNumberMask':'',
          'cardExpiryMonth': '',
          'cardExpiryYear': '',
          'cardCVVD': ''
        })
      }
      else if (this.payType?.promptFor?.toLowerCase() == 'campusCard') {
        this.paymentForm = this.fb.group({
          'campusCardNumber': '',
          'firstName': '',
          'lastName': '',
          'dateOfBirth': '',

        })
      }

      var variableValues
      if (this.permitType == 'daily') {
        variableValues = {
          plate: this.tempPermitFormDaily.value['plate'],
          vehicle: this.tempPermitFormDaily.value['vehicle']
        }
      } else {
        variableValues = {
          vehicle: this.tempPermitFormHourly.value['vehicle'],
          plate: this.tempPermitFormHourly.value['plate'],
          hours: this.tempPermitFormHourly.value['hours']

        }
      }
      const desktopModal = await this.modalCtrl.create({
        component: QrPaymentformPage,
        breakpoints: [0.5, 0.8, 1],
        initialBreakpoint: 1,
        cssClass: 'modal-desktop-long',
        componentProps: {
          vehicle: variableValues.vehicle,
          plate: variableValues.plate,
          paymentForm: this.paymentForm,
          payType: this.payType,
          cartTotal: summary,
          lotID: this.id,
          provinces: this.provinces,
          dailyStartDate: this.permitDetails['startDateObject'],
          dailyEndDate: this.permitDetails['endDateObject'],
          hours: variableValues.hours,
          hourlyTime: this.permitDetails['startTime'],
          hourlyDate: format(new Date(parseISO(this.permitDetails['startDateObject'])), 'yyyy/LL/dd'),
          permitType: this.permitType
        },
      });
      const mobileModal = await this.modalCtrl.create({
        component: QrPaymentformPage,
        breakpoints: [0.5, 0.8, 1],
        initialBreakpoint: 1,
        cssClass: 'modal-mobile-normal',
        componentProps: {
          vehicle: variableValues.vehicle,
          plate: variableValues.plate,
          paymentForm: this.paymentForm,
          payType: this.payType,
          cartTotal: summary,
          lotID: this.id,
          provinces: this.provinces,
          dailyStartDate: this.permitDetails['startDateObject'],
          dailyEndDate: this.permitDetails['endDateObject'],
          hours: variableValues.hours,
          hourlyTime: this.permitDetails['startTime'],
          hourlyDate: format(new Date(parseISO(this.permitDetails['startDateObject'])), 'yyyy/LL/dd'),
          permitType: this.permitType
        },
      });
      const tabletModal = await this.modalCtrl.create({
        component: QrPaymentformPage,
        breakpoints: [0.5, 0.8, 1],
        initialBreakpoint: 1,
        cssClass: 'modal-tablet-normal',
        componentProps: {
          vehicle: variableValues.vehicle,
          plate: variableValues.plate,
          paymentForm: this.paymentForm,
          payType: this.payType,
          cartTotal: summary,
          lotID: this.id,
          provinces: this.provinces,
          dailyStartDate: this.permitDetails['startDateObject'],
          dailyEndDate: this.permitDetails['endDateObject'],
          hours: variableValues.hours,
          hourlyTime: this.permitDetails['startTime'],
          hourlyDate: format(new Date(parseISO(this.permitDetails['startDateObject'])), 'yyyy/LL/dd'),
          permitType: this.permitType
        },
      });
      var modal = await this.dataSRV.getModalType(mobileModal, tabletModal, desktopModal)
      modal.onDidDismiss().then(res => {
        if (res.data != "keep open") {
          this.resetForm()
  if(this.isModal){
    this.modalCtrl.dismiss().then(() => {


      this.navCtrl.back();
      this.openReceipt(res.data['receiptID'])
    })
  } else {
    this.openReceipt(res.data['receiptID'])
  }


        } else{
          this.resetPaymentForm()
        }

      })
      modal.present()
      this.payType = '';
    }

  }
  async openPasswordPage() {

    if ((this.lotPasswordEnabled && this.isModal) || !this.isModal) {
      const modal = await this.modalCtrl.create({
        component: EnterlotpasswordPage, // Component for entering the password
        componentProps: {
          LotNameID: this.id,
          permitType: "qrcode/qr"
        },
      });

      await modal.present();
      const { data } = await modal.onDidDismiss();
      if (data && data.passwordEntered) {
        this.loadData()
      }
    }

  }
  loadData() {
    if (!this.isModal) {

      this.id = this.route.snapshot.paramMap.get('id');



    }
    // this.disclaimer = this.disclaimerSRV.disclaimers.find(disclaimer => disclaimer['data_trigger'] == 'guest-checkout-loaded' && disclaimer['locale'] == this.dataSRV.selected)

    this.dataSRV
      .getData(`permits`).subscribe({
        error: err => {


          this.dataSRV.csrfToken = err.error['state'].csrf_token
        }



      })
    if (this.fromScanner) {
      var parts = this.id.split("/")
      this.id = parts[parts.length - 1];
    }

    this.dataSRV.getData(`permits/qrcode/reservation/${this.id}`).subscribe({
      next: async (data: any) => {

        if (data?.status == 'success') {
          if (data?.error_code == 2028) {
            const modal = await this.modalCtrl.create({
              component: EnterlotpasswordPage, // Component for entering the password
              componentProps: {
                LotNameID: this.id,
                permitType: "qrcode/qr"
              },
            });

            await modal.present();
            const { data } = await modal.onDidDismiss();
            if (data && data.passwordEntered) {
              this.ionViewDidEnter()
            } else {
              this.closeModal()
            }

          }
          if (data?.vehicles.length < 1 && !this.dataSRV?.settings?.vehicles?.guest_vehicle && this.dataSRV.isAuthenticated.value == true) {
            this.noVehiclesAlert()
          } else {
            this.provinces = data['provinces']
            this.lot = data['lot']
            this.vehicles = data['vehicles']
            this.paymentTypes = data['payment_types']
            this.zeroDollarPayment = data['payment_type_zero_dollar']
            this.loaded = true
            if (this.lot['lot_hourly_cost'].length < 1) {
              this.disableHourly = true;
              this.permitType = 'daily'
            } else {
              this.disableHourly = false;
            }
            if (this.lot['TempPermitCost'] == null || !this.lot['lot_allowing_daily']) {
              this.disableDaily = true;
              this.permitType = 'hourly'
            } else {
              this.disableDaily = false;
            }
          }


        } else {
          this.closeModal()

          this.errorHandlerSRV.displayErrorMessage(data, true)
        }

      },
      error: err => {
        this.closeModal()
        this.errorHandlerSRV.displayErrorMessage(err, true)


      }

    })


    // if (this.disclaimer && this.disclaimer['active']) {
    //   this.dataSRV.createAndOpenModal(this.disclaimer).then(data => {
    //     if (data) {
    //
    //     }
    //     else {
    //       this.closeModal()
    //     }
    //   })
    // }
  }
  async ionViewDidEnter() {

      this.loadData()
    

  }
  async noVehiclesAlert() {
    let alert = await this.alertCtrl.create({
      message: this.translateService.instant('keys.data.permits.vehicle_required') || 'A vehicle is required to purchase permits.',
      buttons: [

        {
          text: this.translateService.instant('keys.data.common.cancel') || 'Cancel',
          role: 'cancel',
          handler: async () => {
            this.closeModal()
          }
        }, {
          text: this.translateService.instant('keys.data.vehicles.add_vehicle') || 'Add Vehicle',
          handler: async () => {
            this.closeModal()
            this.router.navigateByUrl('vehicles')
          }
        }]
    })
    await alert.present()
  }
  closeModal() {
    if (this.isModal) {
      this.modalCtrl.dismiss();
    } else {
       this.router.navigate(['home']);
    }
  }
  hourlyChanged() {
    this.tempPermitState.valid = false;
    this.tempPermitState.checking = false
    this.onTempPermitFormHourlyValid(this.tempPermitFormHourly.value);
  }

  dailyChanged() {
    this.tempPermitState.valid = false;
    this.tempPermitState.checking = false
    this.onTempPermitFormDailyValid(this.tempPermitFormDaily.value);
  }
  private onTempPermitFormDailyValid(val: any) {
    if (this.tempPermitFormDaily.valid && this.tempPermitFormDaily.touched) {

      this.tempPermitState.checking = true;

      this.postData = val;

      this.checkValidation(val);

    } else {

      this.tempPermitState.valid = false;
      this.tempPermitState.checking = false;
    }
  }
  private onTempPermitFormHourlyValid(val: any) {
    if (this.tempPermitFormHourly.valid && this.tempPermitFormHourly.touched) {


      this.tempPermitState.checking = true;


      this.postData = val;

      this.checkValidation(val);
    } else {
      this.tempPermitState.valid = false;
      this.tempPermitState.checking = false;
    }

  }
  private checkValidation(data: any) {
    const url = `permits/qrcode/reservation/${this.lot.LotNameID}/check`;
    this.dataSRV.postData(url, data).subscribe({
      next: (res: any) => {
        if (res?.status == 'success') {
          var arr = [],
            keys = Object.keys(res.permit.taxes);

          for (var i = 0, n = keys.length; i < n; i++) {
            var key = keys[i];
            arr[key] = res.permit.taxes[key];
          }
          res.permit.taxes = arr

          this.permitDetails = res['permit'] ? res['permit'] : {};
          this.tempPermitState.checking = false;
          if (this.permitType == 'hourly') {
            if (data['plate'] == this.tempPermitFormHourly.value['plate']) {
              this.errors = {};
              this.tempPermitState.valid = true;
            }
          } else {
            if (data['plate'] == this.tempPermitFormDaily.value['plate']) {
              this.errors = {};
              this.tempPermitState.valid = true;
            }

          }


        } else {
          if (res['errors']) {
            this.tempPermitState.checking = false;
            this.errorHandlerSRV.displayErrorMessage(res, false).then(response => {
              this.errors = response
            })
          } else {
            this.toastSRV.presentErrorToast(res['error'])
          }

        }

      }, error: err => {
        this.tempPermitState.checking = false;
        this.errorHandlerSRV.displayErrorMessage(err, true)
      }



    });
  }
  async openReceipt(receiptID) {
    const desktopModal = await this.modalCtrl.create({
      component: ReceiptPage,
      breakpoints: [0.5, 0.8, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        receiptID: receiptID,
        modalPage: true
      },
    });
    const mobileModal = await this.modalCtrl.create({
      component: ReceiptPage,
      breakpoints: [0.5, 0.85, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        receiptID: receiptID,
        modalPage: true
      },
    });
    const tabletModal = await this.modalCtrl.create({
      component: ReceiptPage,
      breakpoints: [0.5, 0.85, 1],
      initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        receiptID: receiptID,
        modalPage: true
      },
    });
    if (this.platformSRV.device == 'desktop') {
      return await desktopModal.present();
    } else if (this.platformSRV.device == 'mobile') {
      return await mobileModal.present();
    } else if (this.platformSRV.device == 'tablet') {
      return await tabletModal.present();
    }

  }

}
